
/**
 * 해시태그 통계 정보
 */
export type HashtagListResponsePageAllOfThreeContentItemStats = {
  /** 해당 해시태그가 사용된 트윗 수 */
  count?: number;
};
